import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md bg-yellow-100 p-4 mt-4"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "ml-3 flex-1 md:flex md:justify-between items-center" }
const _hoisted_5 = { class: "alert-text" }
const _hoisted_6 = { class: "text-md text-yellow-800 font-semibold" }
const _hoisted_7 = { class: "text-sm text-yellow-800" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3 text-sm md:ml-6 md:mt-0"
}

import { computed } from 'vue';
import { useLicenseStore } from '@/stores/licenseStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolLicenseAlertComponent',
  emits: ['scrollToElement'],
  setup(__props, { emit }) {

const licenseStore = useLicenseStore();

// Emit event if we need actions like scrolling or navigating


const matrix = computed(() => licenseStore.licenseStateMatrix);

const showAlert = computed(() => {
  // We'll show the alert if any of the alert conditions in the matrix are true
  // For example, if showExpiringSoonAlert, showExpiredAlert, etc.
  return (
    matrix.value.showCreateLicensePrompt ||
    matrix.value.showExpiringSoonAlert ||
    matrix.value.showExpiredAlert ||
    matrix.value.showAssignLearnersAlert ||
    matrix.value.showUpcomingIssuanceInfo ||
    matrix.value.showUpcomingIssuanceReminder
  );
});

const title = computed(() => {
  if (matrix.value.showUpcomingIssuanceReminder) {
    return 'License Activation Approaching';
  } else if (matrix.value.showUpcomingIssuanceInfo) {
    return 'License Upcoming';
  } else if (matrix.value.showAssignLearnersAlert) {
    return 'Assign Learners Required';
  } else if (matrix.value.showExpiredAlert) {
    return 'License Expired';
  } else if (matrix.value.showExpiringSoonAlert) {
    return 'License Expiring Soon';
  } else if (matrix.value.showCreateLicensePrompt) {
    return 'No License Found';
  }

  return '';
});

const subtitle = computed(() => {
  if (matrix.value.showUpcomingIssuanceReminder) {
    return 'Your upcoming license will start soon. Please finalize any learner assignments.';
  } else if (matrix.value.showUpcomingIssuanceInfo) {
    return 'Your upcoming license will start in the future. No action is needed at this moment.';
  } else if (matrix.value.showAssignLearnersAlert) {
    return 'Your upcoming license requires assigning learners to products. Please assign learners now.';
  } else if (matrix.value.showExpiredAlert) {
    return 'Your license has expired. Please contact support or create a new license.';
  } else if (matrix.value.showExpiringSoonAlert) {
    return 'Your license is about to expire soon. Please renew to avoid interruptions.';
  } else if (matrix.value.showCreateLicensePrompt) {
    return 'You currently have no license. Please create one to continue.';
  }

  return '';
});

const showButton = computed(() => {
  // Show a button if we have a recommended action
  // For example: create license or renew license
  return (
    matrix.value.showCreateLicensePrompt ||
    matrix.value.showExpiringSoonAlert ||
    matrix.value.showExpiredAlert ||
    matrix.value.showAssignLearnersAlert ||
    matrix.value.showUpcomingIssuanceReminder
  );
});

const alertButtonText = computed(() => {
  if (matrix.value.showUpcomingIssuanceReminder) {
    return 'Review Learners';
  } else if (matrix.value.showAssignLearnersAlert) {
    return 'Assign Learners';
  } else if (matrix.value.showExpiredAlert) {
    return 'Create New License';
  } else if (matrix.value.showExpiringSoonAlert) {
    return 'Renew License';
  } else if (matrix.value.showCreateLicensePrompt) {
    return 'Create License';
  }

  return '';
});

function alertButtonAction() {
  if (matrix.value.showUpcomingIssuanceReminder) {
    emit('scrollToElement', '#allocateLearnersButton');
  } else if (matrix.value.showAssignLearnersAlert) {
    emit('scrollToElement', '#allocateLearnersButton');
  } else if (matrix.value.showExpiredAlert) {
    // Scroll to create license button again
    emit('scrollToElement', '#createLicenseButton');
  } else if (matrix.value.showExpiringSoonAlert) {
    // Scroll to renew license button or navigate
    emit('scrollToElement', '#createLicenseButton');
  } else if (matrix.value.showCreateLicensePrompt) {
    // Scroll to the element that allows creating a license
    emit('scrollToElement', '#createLicenseButton');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (showAlert.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-yellow-alert',
              title: 'rl yellow alert',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(title.value), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(subtitle.value), 1)
            ]),
            (showButton.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600 border-solid border border-yellow-800 rounded-full py-2 px-6",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (alertButtonAction()))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(alertButtonText.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})